import MainSkills from './MainSkills';

export default MainSkills;
